export default __webpack_public_path__ + "static/media/halfAudio.3c4bd433.png";